/**
 * Supabaseクライアント
 * ブラウザ環境でのSupabase接続設定
 */

import { createClient as createSupabaseClient, type SupabaseClient } from '@supabase/supabase-js'
import { createSupabaseAuthStorage, SUPABASE_AUTH_STORAGE_KEY } from '@/lib/auth/supabaseAuthStorage'

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL ?? '').trim()
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim()

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('[Supabase] 必須環境変数が不足しています。')
}

let cachedClient: SupabaseClient | null = null

export function createClient() {
  if (!cachedClient) {
    cachedClient = createSupabaseClient(
      supabaseUrl,
      supabaseAnonKey,
      {
        db: {
          schema: 'public'
        },
        auth: {
          autoRefreshToken: true,
          persistSession: true,
          detectSessionInUrl: true,
          flowType: 'pkce',
          storage: createSupabaseAuthStorage(),
          storageKey: SUPABASE_AUTH_STORAGE_KEY
        },
        global: {
          headers: {
            'x-my-custom-header': 'genbadock-app',
          },
        },
        realtime: {
          params: {
            eventsPerSecond: 10,
          },
        },
      }
    )
  }

  return cachedClient
}

export const supabase = createClient()
